import { useCallback, useState } from "react"
import { useQuery } from "react-query"
import { apiConfig } from "../../config/apiConfig"
import { useCookie } from "../useCookie"
import { useAuth } from "../useAuth"
import apiService from "../../service/apiService"

const LAST_SEEN_KEY = "vz_partner_requests_seen_at"

export function usePartnerRequestAlerts(enabled = true) {
  const { token } = useCookie("vToken")
  const { isAdmin } = useAuth()
  const [lastSeen, setLastSeen] = useState(
    () => window.localStorage.getItem(LAST_SEEN_KEY) ?? "",
  )

  const { data } = useQuery(
    ["getPartnersRequest", "alerts"],
    () =>
      apiService.MakeGetRequest(
        apiConfig.partnair.request({ page: 1, limit: 1 }),
        token,
      ),
    {
      enabled: Boolean(enabled && isAdmin && token),
      refetchInterval: 60_000,
    },
  )

  const total = Number(data?.meta?.totalItems ?? 0)
  const newestCreatedAt = data?.items?.[0]?.createdAt as string | undefined
  const hasNew = Boolean(
    newestCreatedAt &&
      (!lastSeen || new Date(newestCreatedAt) > new Date(lastSeen)),
  )

  const markSeen = useCallback(() => {
    const now = new Date().toISOString()
    window.localStorage.setItem(LAST_SEEN_KEY, now)
    setLastSeen(now)
  }, [])

  return { total, hasNew, markSeen }
}

export function PartnerRequestBadge({
  total,
  hasNew,
}: {
  total: number
  hasNew: boolean
}) {
  if (total <= 0) return null

  return (
    <span
      className={`ms-2 rounded-pill px-2 py-0 text-white ${
        hasNew ? "bg-danger" : "bg-secondary"
      }`}
      style={{ fontSize: 11, fontWeight: 700, lineHeight: "18px" }}
    >
      {hasNew ? `Nouveau · ${total}` : total}
    </span>
  )
}
